import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useContext } from 'react';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import { useTranslation } from 'react-i18next'
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout';
import ResponsiveExpeditionList from '@app/pages/customer/expedition-list/ResponsiveExpeditionList';

const CustomerExpeditionListPage = () => {
  const { loggedUser } = useContext(AuthenticatedUserContext);

  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout
      title={t(`expeditions.AllExpedition`, `Všechny expedice`)}
      oneOfPermission={[
        PermissionTypesEnum.PERMISSION_EXPEDITION_LIST_READ,
        PermissionTypesEnum.PERMISSION_EXPEDITION_LIST_RW,
        PermissionTypesEnum.PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE,
      ]}
    >
      {/*// @ts-ignore*/}
      {/* <Card>{loggedUser?.companyId && <AllExpedition customerId={loggedUser.companyId} />}</Card> */}
      <ResponsiveExpeditionList customerId={loggedUser.companyId} />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CustomerExpeditionListPage);
